import { IDashboardLayout } from 'components/Visualization/CDashboard/types';

import { availableWidgets } from './widget';

export const ec2SummaryWidgets: IDashboardLayout = {
  id: 'dashboard_1',
  title: 'Dashboard Title',
  widgets: [
    {
      type: 'pie-chart',
      i: 'byOS',
      x: 0,
      y: 0,
      w: 6,
      h: 8,
      minH: 2,
      minW: 2,
      isResizable: false,
    },

    {
      type: 'pie-chart',
      i: 'byTechnology',
      x: 6,
      y: 0,
      w: 6,
      h: 8,
      minH: 2,
      minW: 2,
      isResizable: false,
    },
    {
      type: 'pie-chart',
      i: 'byVulnerabilities',
      x: 0,
      y: 6,
      w: 6,
      h: 8,
      isResizable: false,
    },
    {
      type: 'pie-chart',
      i: 'byCvssScoreOnVulnerabilities',
      x: 6,
      y: 6,
      w: 6,
      h: 8,
      minH: 4,
      minW: 2,
      isResizable: false,
    },
  ],
  available: availableWidgets,
};
